import axios from 'axios';
import { getApiOrigin } from '../utils/config';

// Get the chat service URL based on environment
const getChatBaseUrl = () => {
  // For local development, use the chat service port
  if (process.env.REACT_APP_CHATBOT_URL) {
    return process.env.REACT_APP_CHATBOT_URL;
  }

  // For deployed environments, use the FMP APIs base URL without /v1
  const apisBase = getApiOrigin();
  return apisBase.replace('/v1', '');
};

// Create chat API client with proper configuration
const chatApiClient = axios.create({
  baseURL: getChatBaseUrl(),
  withCredentials: true,
  transformResponse: axios.defaults.transformResponse.concat(
    params => params.data || params
  ),
});

/**
 * Fetch chat configuration from the chat service
 * @param {Object} params - Query parameters for chat config
 * @param {string} params.parcelCode - The parcel code
 * @param {string} params.postcode - The postcode (optional)
 * @param {string} params.orderId - The order ID (optional)
 * @returns {Promise<Object>} Chat configuration response
 */
export const fetchChatConfig = params =>
  chatApiClient.get('/chat/config', { params }).then(response => response.data);
